/** @format */

import { Avatar, Box, ListItemAvatar, ListItemText, Stack, SvgIcon, Typography } from '@mui/material';
import Mail04Icon from '@untitled-ui/icons-react/build/esm/Mail04';

import { get } from 'lodash';
import { useCallback, useEffect } from 'react';
import toast from 'react-hot-toast';
import { useDispatch } from 'react-redux';
import TypographyTooltip from 'src/components/typography-tooltip';
import { bookingFindCarTabs } from 'src/pages/booking/helper';
import { setPushResponseFocusToBookingRequest, setPushResponseToBookingRequest } from 'src/pages/booking/slices/booking-slice';

const BookingRequestDismissNotice = ({ toastId, content, userConfirm }) => {
  const dispatch = useDispatch();
  const userConfirmId = userConfirm.id;
  const requestId = content.id;
  const bookingCondition = content.bookingCondition;

  const openRequestNoticeFocus = useCallback((requestId, tab) => {
    dispatch(
      setPushResponseFocusToBookingRequest({
        tab: tab,
        bookingFindCarTab: bookingFindCarTabs.carResponse.value,
        requestId
      })
    );
    toast.remove(toastId);
  }, []);

  useEffect(() => {
    if (toastId) {
      dispatch(
        setPushResponseToBookingRequest({
          requestId: requestId,
          userConfirmId: userConfirmId,
          isAccepted: false,
          bookingConditionId: bookingCondition.id
        })
      );
    }
  }, [toastId, requestId, userConfirmId, bookingCondition.id]);

  return (
    <>
      <ListItemAvatar sx={{ mt: 0.5 }}>
        <Avatar>
          <SvgIcon sx={{ color: 'warning.main' }}>
            <Mail04Icon />
          </SvgIcon>
        </Avatar>
      </ListItemAvatar>
      <ListItemText
        primary={
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              flexWrap: 'wrap',
              m: 0
            }}
          >
            <Stack direction="row" columnGap={0.5}>
              <Typography variant="body2">Nhà xe </Typography>
              <Typography variant="h6" color="warning.main">
                {get(userConfirm, 'displayName', '')}
              </Typography>
              <Typography variant="body2">không nhận kèo.</Typography>

              {/* <Typography variant="caption"> đã nhận</Typography> */}
            </Stack>
            <Stack direction="row" columnGap={1} justifyContent="space-between" width="100%">
              <Typography
                sx={{ mr: 0.5, textDecoration: 'underline', cursor: 'pointer' }}
                variant="subtitle1"
                {...(toastId && {
                  onClick: () => {
                    openRequestNoticeFocus(content.id, { id: bookingCondition.id, name: bookingCondition.name });
                  }
                })}
              >
                {content.tagKey}
              </Typography>
            </Stack>

            <TypographyTooltip mixText={content.message} maxLines={5} variant="body2" />
            {/* 
                  <Typography sx={{ mr: 0.5 }} variant="body2">
                    {request.message}
                  </Typography> */}
          </Box>
        }
        primaryTypographyProps={{ component: 'div' }} // Chuyển thẻ <p> thành <div>
        secondaryTypographyProps={{ component: 'div' }}
        sx={{ my: 0 }}
      />
    </>
  );
};

export default BookingRequestDismissNotice;
